import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getHasSimulatorAccount = (state) => {
    return state.hasSimulatorAccount;
};
export default {
    getHasSimulatorAccount,
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
};
